import OtpButton from "@components/account/OtpButton";
import { useTranslation } from "react-i18next";
import { getOtp, getOtpAuthenticated } from "@utils/api/account";
import { HttpError } from "@utils/http";

interface OtpInputProps {
  setErrorMessage: (message: string) => void;
  otpFormId: string;
  mobile: string;
  purpose: string;
  useAuthenticatedApi?: boolean;
}

export default function OtpInput({
  setErrorMessage,
  otpFormId,
  mobile,
  purpose,
  useAuthenticatedApi = false,
}: OtpInputProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 space-x-2">
      <input
        id={otpFormId}
        name={otpFormId}
        type={otpFormId}
        pattern={"[0-9]{6}"}
        onInvalid={(e) =>
          (e.target as HTMLSelectElement).setCustomValidity(
            t("account.tooltip.otpPattern")
          )
        }
        onInput={(e) => (e.target as HTMLSelectElement).setCustomValidity("")}
        required
        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-primary focus:outline-none focus:ring-primary sm:text-sm"
      />
      <OtpButton
        className="flex w-48 justify-center rounded-md border border-transparent bg-primary py-2 px-4 text-sm font-medium shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-50 disabled:text-gray-500"
        buildOtpRequest={() => ({ mobile: mobile, purpose: purpose })}
        handleOtpRateLimit={(resp) => {
          setErrorMessage(
            t("account.signUp.notification.otpRateLimited", {
              nextRetrySecond: Math.ceil(
                (resp.nextRetryUnixMs - Date.now()) / 1000
              ),
            })
          );
        }}
        otpApi={useAuthenticatedApi ? getOtpAuthenticated : getOtp}
        handleOtpRequestError={(e) => {
          console.error(e);
          if (e instanceof HttpError) {
            setErrorMessage(
              t("account.signUp.notification.otpRequestFailed", {
                error: e.message,
              })
            );
          } else {
            setErrorMessage(t("common.notification.unknownError") as string);
          }
        }}
        // when OTP is sent, button would grey out and show countdown
        countDownAppearance={{
          className:
            "flex w-full justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-not-allowed border-gray-200 bg-gray-500 text-primary",
          buildChildren: (countDownSecond: number) =>
            t("account.actions.requestOtp.countDown", {
              countdownSecond: countDownSecond,
            }),
        }}
      >
        {t("account.actions.requestOtp.canClick")}
      </OtpButton>
    </div>
  );
}
